'use strict';

var ContactForm = React.createClass({
    getInitialState: function() {
        return {
            sended: 0,
            submit_disabled: false,
            check_wrong: false,
            wrong_name: false,
            wrong_mail: false,
            wrong_phone: false,
            wrong_message: false,
            user_name:"",
            user_email:"",
            user_phone:"",
            user_message:"",
            placeholders: lang.contacts.placeholders
        }
    },
    componentDidMount: function() {

    },
    componentWillMount: function() {

    },
    onClickSuccess: function(){
        this.setState({sended: 0});
    },
    onChangeName: function(e){
        this.setState({user_name: e.target.value, submit_disabled: false, wrong_name: false});
    },
    onChangeEmail: function(e){
        this.setState({user_email: e.target.value, submit_disabled: false, wrong_mail: false});
    },
    onChangeNumber: function(e){
        this.setState({user_phone: e.target.value, submit_disabled: false});
    },
    onChangeMessage: function(e){

        this.setState({user_message: e.target.value, submit_disabled: false, wrong_message: false});
        var _this = this;
        setTimeout(function(){
            if(!_this.state.user_message.length){
                $("#contacts_message").addClass("empty");
            }else{
                $("#contacts_message").removeClass("empty");
            }
            console.log(_this.state.user_message.length);
        }, 100);
    },
    onSubmitMouseOver: function(e){
        this.setState({
            check_wrong: true,
            wrong_name: this.state.user_name=="" ? true : false,
            wrong_mail: this.state.user_email=="" ? true : false,
            wrong_message: this.state.user_message=="" ? true : false
        });
    },
    onSubmitMouseOut: function(e){
        this.setState({check_wrong: false});
    },
    onClick: function(){
        console.log("submit: ", this.state.user_name, this.state.user_email, this.state.user_phone, this.state.user_message);
        if(this.state.wrong_name || this.state.wrong_mail || this.state.wrong_message) return;
        this.state.sended++;
        this.setState({sended: 2, submit_disabled: true});
        $.ajax({
            type: 'POST',
            url: 'submit/',
            data: { messageMe: "", user_name: this.state.user_name, user_email: this.state.user_email, user_phone: this.state.user_phone, user_message: this.state.user_message},
            success: function(json) {
                console.log(json);
            },
            error:  function(error){
                console.log(error);
            }
        });
        //return;
    },
    render:function() {
        var form_class = "";

        var submit_value = "Send";
        var submit_className = this.state.wrong_name || this.state.wrong_mail || this.state.wrong_message ? "disabled" : "enabled";
        var MESSAGE_className = this.state.check_wrong && this.state.wrong_message ? "required ":"";

        if(!this.state.user_message.length){
            MESSAGE_className += "empty ";
        }

        form_class += this.state.sended == 1 ? "sended_once " : "";
        form_class += this.state.sended == 2 ? "sended_twice " : "";

        return (
            <form className={form_class}>
                <input type="text" className={this.state.check_wrong && this.state.wrong_name ? "required":""} required onChange={this.onChangeName} placeholder={this.state.check_wrong ? this.state.placeholders.full_name.require : this.state.placeholders.full_name.default} value={this.state.user_name}/>
                <input type="email" className={this.state.check_wrong && this.state.wrong_mail ? "required":""} required onChange={this.onChangeEmail} placeholder={this.state.check_wrong ? this.state.placeholders.email.require : this.state.placeholders.email.default}/>
                <input type="tel" onChange={this.onChangeNumber} placeholder={this.state.check_wrong && this.state.placeholders.phone.require ? this.state.placeholders.phone.require : this.state.placeholders.phone.default}/>
                <textarea id="contacts_message" required  className={MESSAGE_className} onChange={this.onChangeMessage} placeholder={this.state.check_wrong ? this.state.placeholders.text.require : this.state.placeholders.text.default}></textarea>
                <input type="button" className={submit_className} disabled={this.state.submit_disabled ? true : false} onMouseOver={this.onSubmitMouseOver} onMouseOut={this.onSubmitMouseOut} onClick={this.onClick} value={submit_value}/>
                <div className="sended_succes" onClick={this.onClickSuccess}>
                    <div>
                        <img src="img/successful.svg"/>
                    </div>
                </div>
            </form>

        )}
});